import SigliveServiceV1 from 'Service/sigliveServiceV1';

const getPublishStatuses = async () => {
  const { data } = await SigliveServiceV1({ method: 'GET', url: '/briefs/draft-statuses' });

  return data;
};

export default getPublishStatuses;
